import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "src/components/ui/card";
import { newProduct } from "src/assets/images";
import { useQuery } from "@tanstack/react-query";
import { getItemsNew } from "src/api";
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import { renderCurrency } from "../renderCurrency";


const SimilarProducts = () => {
    const { conversionRates } = useProtectedRoutesContext()
    const navigate = useNavigate();

    const { data: items } = useQuery({
        queryKey: ["getItemsNew"],  // Refetch when selectedMaterial changes
        queryFn: () => getItemsNew(),
    });


    return (
        <div>
            {items?.data && items.data.length > 0 ?
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 ">
                    {items?.data?.map((product) => (
                        <Card key={product.id} className="cursor-pointer fatix-card-shop-container"
                            onClick={() => {
                                navigate(`/product/${product.id}`);
                                window.scrollTo(0, 0);
                            }}
                        >
                            <CardHeader className="p-0">
                                <img src={product?.itemImages?.length > 0 ? product?.itemImages[0].url : newProduct} alt={product.name} className="w-full h-[320px] object-cover" />
                            </CardHeader>
                            <CardContent className="flex justify-between p-0 mt-2">
                                <CardTitle className="fatix-product-title">{product?.design_number}</CardTitle>
                                <span className="text-lg font-semibold fatix-product-title">{renderCurrency(product?.grade?.price * conversionRates[product.materialId])}</span>
                            </CardContent>
                        </Card>
                    ))}
                </div>
                :
                <div className="no-data-value-stat mb-[100px] mt-[50px]">
                    {/* <h1 className="mb-[20px]">No New Arrival Currently</h1> */}
                    <a className="text-white px-20 py-3 rounded-lg shop-class " href="/shop">
                        Go to Shop
                    </a>
                </div>
            }
        </div>
    )
};

export default SimilarProducts;